import type { AxiosResponse } from 'axios';

import client from 'api/client';
import type { RecommendedJobsResponse } from 'types';

export const getRecommendedJobs = (
    country: string,
    description: string
): Promise<AxiosResponse<RecommendedJobsResponse>> => {
    return client.get('/recommended_jobs', { params: { country, description } });
};
